/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { loadingPlaceholder } from "./utils/loadingPlaceholder";
import { isJsonString, tooltip } from "./utils/functions";
import { customSelectsInit } from "./customSelects";
import { fileInputInit } from "./fileInput";
import { durationPickerInit } from "./durationPicker";
import { datetimePickerInit } from "./dateTimePicker";
import { lazyLoadInit } from "./lazyLoad";
import { customTabsInit } from "./tabs";
import { generateSlugInit } from "./url";
import { imageUploaderInit } from "./images";
import { formValidationInit } from "./formValidation";
import { borrowingInit } from "./borrowingRequest";

// import {customFieldsInit} from "../action/custom-fields";
// import {borrowingInit} from "../action/borrowing-request";

function getAJAXModalContent(name, size, templateType, templateVariable, updateList, updateHTML, reloadPage, prevModalId, controlId) {
  var modalContentSelector = '#kaa-modal-content-' + name;
  var params = new URLSearchParams({
    type: templateType
  });
  if (templateVariable) {
    params.append('id', templateVariable);
  }
  loadingPlaceholder.start(modalContentSelector, size);
  httpRequest({
    url: adminConfig.routes.getTemplate,
    data: params
  }).then(function (response) {
    if (response && response.data) {
      var modalContentEl = document.getElementById('kaa-modal-content-' + name);
      if (modalContentEl) {
        if (response.data.html) {
          modalContentEl.innerHTML = response.data.html;
          tooltip(modalContentSelector);
          customSelectsInit(modalContentSelector);
          imageUploaderInit(modalContentSelector);
          fileInputInit(modalContentSelector);
          formValidationInit(modalContentSelector);
          // codeEditorInit(modalContentSelector);
          // textEditorInit(modalContentSelector);
          customTabsInit(modalContentSelector);
          generateSlugInit(modalContentSelector);
          lazyLoadInit(modalContentSelector);
          durationPickerInit(modalContentSelector);
          datetimePickerInit(modalContentSelector);

          // customFieldsInit(modalContentSelector);
          borrowingInit(modalContentSelector);
          var submitBtnElements = modalContentEl.querySelectorAll('.submit-btn');
          for (var i = 0; i < submitBtnElements.length; i++) {
            var submitBtn = submitBtnElements[i];
            submitBtn.dataset.modal = name;
            if (reloadPage) {
              submitBtn.dataset.reload = 'true';
            }
            if (updateHTML) {
              submitBtn.dataset.html = 'true';
            }
            if (updateList) {
              submitBtn.dataset.list = 'true';
            }
            if (prevModalId) {
              submitBtn.dataset.prevModal = prevModalId;
            }
            if (controlId) {
              submitBtn.dataset.control = controlId;
            }
          }
        }
      }
    }
  })["finally"](function () {
    loadingPlaceholder.finish(modalContentSelector);
  });
}
export var modal = {
  init: function init(_ref) {
    var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$backdrop = _ref.backdrop,
      backdrop = _ref$backdrop === void 0 ? 'true' : _ref$backdrop,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? true : _ref$header,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Modal Title' : _ref$title,
      _ref$ajax = _ref.ajax,
      ajax = _ref$ajax === void 0 ? true : _ref$ajax,
      _ref$templateType = _ref.templateType,
      templateType = _ref$templateType === void 0 ? '' : _ref$templateType,
      templateVariable = _ref.templateVariable,
      _ref$updateList = _ref.updateList,
      updateList = _ref$updateList === void 0 ? true : _ref$updateList,
      _ref$updateHTML = _ref.updateHTML,
      updateHTML = _ref$updateHTML === void 0 ? false : _ref$updateHTML,
      _ref$reloadPage = _ref.reloadPage,
      reloadPage = _ref$reloadPage === void 0 ? false : _ref$reloadPage,
      _ref$prevModalId = _ref.prevModalId,
      prevModalId = _ref$prevModalId === void 0 ? '' : _ref$prevModalId,
      _ref$bodyClasses = _ref.bodyClasses,
      bodyClasses = _ref$bodyClasses === void 0 ? '' : _ref$bodyClasses,
      controlId = _ref.controlId;
    if (!name) return;
    var template = '<div class="modal modal-blur kaa-modal fade" id="kaa-modal-' + name + '" data-list="' + updateList + '" data-size="' + size + '" data-id="' + templateVariable + '" data-type="' + templateType + '" tabindex="-1" aria-hidden="true">' + '<div class="modal-dialog modal-dialog-centered modal-' + size + '" role="document">' + '<div class="modal-content">';
    if (header) {
      template += '<div class="modal-header">' + '<h5 class="modal-title">' + title + '</h5>' + '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' + '</div>';
    } else {
      template += '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>';
    }
    template += '<div class="modal-body ' + bodyClasses + ' modal-body-' + size + '" id="kaa-modal-content-' + name + '"></div>' + '</div>' + '</div>' + '</div>';
    document.body.insertAdjacentHTML('beforeend', template);
    var config = {
      keyboard: backdrop !== 'static',
      backdrop: backdrop
    };
    // не создавать backdrop если уже есть один
    if (document.querySelectorAll('.modal-backdrop').length > 0) {
      config.backdrop = false;
    }
    // добавляем в очередь и проверяем если есть уже модальное окно, то скрываем предыдущее
    if (adminConfig.modals.length > 0) {
      document.getElementById(adminConfig.modals[adminConfig.modals.length - 1]).style.opacity = "0";
    }
    adminConfig.modals.push('kaa-modal-' + name);
    var modal = new bootstrap.Modal(document.getElementById('kaa-modal-' + name), config);
    modal.show();
    document.getElementById('kaa-modal-' + name).addEventListener("shown.bs.modal", function () {
      // ???
      document.body.classList.add("modal-open");
    });
    document.getElementById('kaa-modal-' + name).addEventListener("hidden.bs.modal", function () {
      this.remove();
      // удаляем из очереди и если есть предыдущее модальное окно, то показываем его
      adminConfig.modals.pop();
      if (adminConfig.modals.length > 0) {
        document.getElementById(adminConfig.modals[adminConfig.modals.length - 1]).style.opacity = 1;
      }
    });
    if (ajax) {
      getAJAXModalContent(name, size, templateType, templateVariable, updateList, updateHTML, reloadPage, prevModalId, controlId);
    }
  },
  update: function update(name) {
    var modalEl = document.getElementById('kaa-modal-' + name);
    if (modalEl) {
      var templateType = modalEl.dataset.type;
      var templateVariable = modalEl.dataset.id;
      var size = modalEl.dataset.size;
      var updateList = modalEl.dataset.list ? modalEl.dataset.list === 'true' : true;
      getAJAXModalContent(name, size, templateType, templateVariable, updateList);
    }
  },
  remove: function remove(name) {
    var modal = bootstrap.Modal.getInstance(document.getElementById('kaa-modal-' + name));
    document.getElementById('kaa-modal-' + name).addEventListener('hidden.bs.modal', function () {
      this.remove();
    });
    modal.hide();
  },
  removeAll: function removeAll() {
    var modalId,
      modals = document.querySelectorAll('.kaa-modal');
    for (var i = 0; i < modals.length; i++) {
      modalId = modals[i].id;
      var _modal = bootstrap.Modal.getInstance(modalId);
      modals[i].addEventListener('hidden.bs.modal', function () {
        this.remove();
      });
      _modal.hide();
    }
  }
};

/**
 * @property {string} modalTitle
 */
export function modalInit() {
  document.addEventListener("click", function (e) {
    if (!e.target.matches(".open-modal")) return;
    e.preventDefault();
    var rawJSON = e.target.dataset.modal;
    if (rawJSON && isJsonString(rawJSON)) {
      var json = JSON.parse(rawJSON);
      var modalId = json.id;
      var modalTemplate = json.template;
      if (!modalTemplate) return;
      var modalTemplateVariable = json.variable;
      var modalSize = json.size;
      // update list after modal action
      var isList = json.list ? json.list === 'true' : true;
      // update html after modal action
      var isHTML = json.html ? json.html === 'true' : false;
      // reload page after modal action
      var reload = json.reload ? json.reload === 'true' : false;
      var modalBackdrop = json.backdrop ? json.backdrop : true;
      var modalTitle = json.title ? json.title : 'Modal Title 👌';
      var bodyClasses = json.bodyClasses ? json.bodyClasses : '';
      var prevModalId = json.prevModal;
      // update control (select) after modal action
      var controlId = e.target.dataset.control;
      modal.init({
        name: modalId,
        size: modalSize,
        templateType: modalTemplate,
        templateVariable: modalTemplateVariable,
        updateList: isList,
        updateHTML: isHTML,
        reloadPage: reload,
        backdrop: modalBackdrop,
        title: modalTitle,
        prevModalId: prevModalId,
        bodyClasses: bodyClasses,
        controlId: controlId
      });
    } else {
      console.warn('rawJSON is not valid JSON');
    }
  });
}